var map = {
	"./de/mechaName.png": "t1St",
	"./en/mechaName.png": "9sOA",
	"./es/mechaName.png": "y8Tf",
	"./fr/mechaName.png": "d/H+",
	"./ja/mechaName.png": "F1ql",
	"./ko/mechaName.png": "SRe7",
	"./pt/mechaName.png": "RvoA",
	"./ru/mechaName.png": "NcLS",
	"./tc/mechaName.png": "0tJx",
	"./th/mechaName.png": "Vajg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "OjBo";